import script from "./Carousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./Carousel.vue?vue&type=script&setup=true&lang=ts"

import "./Carousel.vue?vue&type=style&index=0&id=3400f3ad&lang=css"

const __exports__ = script;

export default __exports__